import React from 'react';
import classnames from 'classnames'
import { Formik, Form } from 'formik';
import BbInput from '../styling/bbInput';
import { withLocalize, Translate } from 'react-localize-redux';

class SharingGroupAddGroupPopup extends React.Component {
    render() {
        return (
            <>
                <Formik
                    initialValues={{ groupTitle: '' }}
                    onSubmit={(values) => this.props.add(values.groupTitle)}
                >
                    {({ values }) => (
                        <Form autoComplete="off">
                            <BbInput name="groupTitle" type="text" label={this.props.translate('Common.Title')} placeholder={{ type: 'column' }} />
                            <div className="modal-inner-buttons" style={{ marginTop: '3em' }}>
                                <button type="submit" disabled={values.groupTitle === ''} className={classnames('bb-button bold-bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} >
                                    <Translate id="Common.Create" />
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </>
        )
    }
}

export default withLocalize(SharingGroupAddGroupPopup);